<div class="widget" [ngClass]="widgetClass">
    <div class="row widget__header d-flex align-items-center" [ngClass]="widgetHeaderClass">
        <div class="col-sm-12 col-md-12 col-lg-6 widget__container">
            <ng-content select=".widget__header--left-side"></ng-content>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-6 widget__container">
            <ng-content select=".widget__header--right-side"></ng-content>
        </div>
    </div>
    <div class="widget__container">
        <ng-content select=".widget__content"></ng-content>
    </div>
</div>
